<template>
  <section class="stores">
    <div v-if="HCP_IF == 'CK' && request_list != ''">
      <div style="background-color: white; padding: 30px; border-radius: 10px; margin-bottom: 10px">
        <!-- <h1 style="font-size: 20px"></h1> -->
        <p class="P_XT" style="">审批详情</p>
        <!-- <p style="font-size: 14px">
        申请类型：{{approval_request_GetReason_text.approval_type == 'store'?
        '门店新增':approval_request_GetReason_text.approval_type == 'ClaimStore'?
        '门店认领':approval_request_GetReason_text.approval_type == 'store_edit'?
        '门店编辑':approval_request_GetReason_text.approval_type == 'store_astig'?
        '门店编辑':approval_request_GetReason_text.approval_type == 'store_try'?'门店编辑':''}} 申请人：{{ request_list_username }}
      </p> -->
        <el-steps :space="400" :active="num_zt" finish-status="success">
          <el-step
            v-for="(item, index) in request_list.ApprovalDataInfoList"
            :key="index"
            :status="item.adireason == '-1' ? 'error' : ''"
            :title="item.uername"
            :description="
              item.adireason == 0
                ? '(已审批) ' + (item.date != null ? item.date : '')
                : item.adireason == 1
                ? '(未审批) ' + (item.date != null ? item.date : '')
                : item.adireason == -1
                ? '(已驳回) ' + (item.date != null ? item.date : '')
                : item.adireason == 2
                ? '(待审批) ' + (item.date != null ? item.date : '')
                : ''
            "
          ></el-step>
        </el-steps>
        <div v-if="request_list.isadmin && SP_IF == 'SP'">
          <el-alert title="请在下方补充信息" style="margin-top: 20px" type="warning"></el-alert>
          <br />
          <div class="demo-input-suffix">
            <span style="color: red">*</span>
            HCP ID
            <el-input v-model="approval_request_Put_Material_list.data.HCPID" style="width: 250px" placeholder="请输入"></el-input>
          </div>
        </div>
        <el-alert
          v-if="description_text != ''"
          title="驳回理由"
          type="error"
          style="margin-top: 20px"
          :description="description_text"
          :closable="false"
          show-icon
        ></el-alert>
        <div v-if="SP_IF == 'SP'" style="margin-top: 20px; margin-bottom: 20px">
          <el-button type="success" @click="submit_approvals()">同 意</el-button>
          <el-button type="danger" @click="dialogVisible = true">驳 回</el-button>
        </div>
        <!-- <el-divider></el-divider> -->
      </div>
    </div>
    <el-form ref="form" :model="form" :rules="editFormRules" label-width="160px" label-position="left">
      <div style="background-color: white; padding: 30px; border-radius: 10px">
        <p class="P_XT" style="">HCP基本信息</p>
        <el-row v-if="form.HCPID">
          <el-col :span="7" :xs="24">
            <el-form-item label="HCP ID" prop="HCPID">
              <el-input :disabled="true" v-model="form.HCPID" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="7" :xs="24">
            <el-form-item label="姓名" prop="Name">
              <el-input :disabled="HCP_IF == 'CK'" v-model="form.Name" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col v-if="OLD_IF && old_value.Name !== form.Name" :span="7" :xs="24" class="yz_cls">
            {{ old_value_titile }}：{{ !old_value.Name ? '空' : old_value.Name }}
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="7" :xs="24">
            <el-form-item label="性别" prop="Gender">
              <el-select :disabled="HCP_IF == 'CK'" v-model="form.Gender" clearable placeholder="请选择">
                <el-option label="男" value="男"></el-option>
                <el-option label="女" value="女"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col v-if="OLD_IF && old_value.Gender !== form.Gender" :span="7" :xs="24" class="yz_cls">
            {{ old_value_titile }}：{{ !old_value.Gender ? '空' : old_value.Gender }}
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="7" :xs="24">
            <el-form-item label="医院名称" prop="HospitalName">
              <!-- <el-input :disabled='HCP_IF == "CK"' v-model="form.HospitalName" placeholder="请输入"></el-input> -->
              <el-select
                :disabled="HCP_IF == 'CK'"
                @change="MultipleHospitalchange($event, 'yy')"
                v-model="form.HospitalName"
                filterable
                remote
                :remote-method="HospitalName_chage"
                ref="select1"
                @hook:mounted="cancalReadOnly"
                @visible-change="cancalReadOnly"
                clearable
                collapse-tags
                placeholder="请输入"
              >
                <el-option v-for="item in HospitalName_options" :label="item.Name" :value="item.Name"></el-option>
              </el-select>
              <!-- <el-select  :disabled='HCP_IF == "CK"' v-model="form.Hospitallame" clearable placeholder="请输入">
              <el-option label="11" value="1"></el-option>
            </el-select> -->
            </el-form-item>
          </el-col>
          <el-col v-if="OLD_IF && old_value.bwacctnumber !== form.bwacctnumber" :span="7" :xs="24" class="yz_cls">
            {{ old_value_titile }}：{{ !old_value.bwacctnumber ? '空' : old_value.bwacctnumber }}
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="7" :xs="24">
            <el-form-item label="多点医院名称">
              <el-select
                :disabled="HCP_IF == 'CK'"
                @change="MultipleHospitalchange($event, 'ddyy')"
                v-model="form.MultipleHospitalName"
                filterable
                remote
                :remote-method="HospitalName_chage"
                ref="select"
                @hook:mounted="cancalReadOnly"
                @visible-change="cancalReadOnly"
                clearable
                collapse-tags
                placeholder="请输入"
              >
                <el-option v-for="item in HospitalName_options" :label="item.Name" :value="item.Name"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col v-if="OLD_IF && old_value.multiple_bwacctnumber !== form.multiple_bwacctnumber" :span="7" :xs="24" class="yz_cls">
            {{ old_value_titile }}：{{ !old_value.multiple_bwacctnumber ? '空' : old_value.multiple_bwacctnumber }}
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="7" :xs="24">
            <el-form-item label="一级科室" prop="stair_departments_id_Name">
              <!-- <el-input :disabled='HCP_IF == "CK"' v-model="form.stair_departments_id_Name" placeholder="请输入"></el-input> -->
              <el-select
                :disabled="HCP_IF == 'CK'"
                v-model="form.stair_departments_id_Name"
                @change="Departments_change($event)"
                placeholder="请选择"
              >
                <el-option v-for="item in stair_list" :label="item.Name" :value="item.Name"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col v-if="OLD_IF && old_value.stair_departments_id_Name !== form.stair_departments_id_Name" :span="7" :xs="24" class="yz_cls">
            {{ old_value_titile }}：{{ !old_value.stair_departments_id_Name ? '空' : old_value.stair_departments_id_Name }}
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="7" :xs="24">
            <el-form-item label="二级科室" prop="second_departments_id_Name">
              <!-- <el-input :disabled='HCP_IF == "CK"' v-model="form.second_departments_id_Name" placeholder="请输入"></el-input> -->
              <el-select :disabled="HCP_IF == 'CK'" v-model="form.second_departments_id_Name" @change="second_change($event)" placeholder="请选择">
                <el-option v-for="item in second_list" :label="item.Name" :value="item.Name"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col v-if="OLD_IF && old_value.second_departments_id_Name !== form.second_departments_id_Name" :span="7" :xs="24" class="yz_cls">
            {{ old_value_titile }}：{{ !old_value.second_departments_id_Name ? '空' : old_value.second_departments_id_Name }}
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="7" :xs="24">
            <el-form-item label="职称" prop="Title">
              <!-- <el-input :disabled='HCP_IF == "CK"' v-model="form.Title" placeholder="请输入"></el-input> -->
              <el-select @change="level_post" :disabled="HCP_IF == 'CK'" v-model="form.Title" clearable placeholder="请选择">
                <el-option v-for="item in SpeakerIndexLists.Level6" :label="item.TypeName" :value="item.TypeName"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col v-if="OLD_IF && old_value.Title !== form.Title" :span="7" :xs="24" class="yz_cls">
            {{ old_value_titile }}：{{ !old_value.Title ? '空' : old_value.Title }}
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="7" :xs="24">
            <el-form-item label="省份" prop="province_name">
              <!-- <el-input :disabled='HCP_IF == "CK"' v-model="form.province_name" placeholder="请输入"></el-input> -->
              <el-select :disabled="true" v-model="form.province_name" @change="province_change($event)" placeholder="请选择">
                <el-option v-for="item in region_list" :label="item.name" :value="item.name"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col v-if="OLD_IF && old_value.province_name != form.province_name" :span="7" :xs="24" class="yz_cls">
            {{ old_value_titile }}：{{ !old_value.province_name ? '空' : old_value.province_name }}
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="7" :xs="24">
            <el-form-item label="城市名称" prop="city_name">
              <!-- <el-input :disabled='HCP_IF == "CK"' v-model="form.city_name" placeholder="请输入"></el-input> -->
              <el-select :disabled="true" v-model="form.city_name" @change="city_change($event)" placeholder="请选择">
                <el-option v-for="item in city_list" :label="item.name" :value="item.name"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col v-if="OLD_IF && old_value.city_name != form.city_name" :span="7" :xs="24" class="yz_cls">
            {{ old_value_titile }}：{{ !old_value.city_name ? '空' : old_value.city_name }}
          </el-col>
        </el-row>
        <!-- <el-row v-if='HCP_IF != "ADD" && ( BU_IF_SB_JT || MKT_IF )'>
          <el-col :span="7" :xs="24">
            <el-form-item label="术者123标签" >
              <el-input :disabled='true' v-model="form.Surgeon_Label" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col> -->
        <!-- <el-col v-if="OLD_IF && old_value.Surgeon_Label !== form.Surgeon_Label" :span="7" :xs="24" class="yz_cls">
            {{old_value_titile}}：{{ !old_value.Surgeon_Label?'空':old_value.Surgeon_Label }}
          </el-col> -->
        <!-- </el-row> -->
        <el-row v-if="HCP_IF != 'ADD'">
          <el-col :span="7" :xs="24">
            <el-form-item label="APEX Vendor Number">
              <el-input :disabled="true" v-model="form.vendor_number" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="HCP_IF != 'ADD'">
          <el-col :span="7" :xs="24">
            <el-form-item label="框架协议有效期">
              <!-- <el-input :disabled='HCP_IF == "CK"' v-model="form.city_name" placeholder="请输入"></el-input> -->
              <el-date-picker :disabled="YXQ_IF == false" v-model="form.ExpiryDate" type="date" placeholder="请输入"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col v-if="OLD_IF && old_value.ExpiryDate != form.ExpiryDate" :span="7" :xs="24" class="yz_cls">
            {{ old_value_titile }}：{{ !old_value.ExpiryDate ? '空' : old_value.ExpiryDate }}
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="7" :xs="24">
            <el-form-item label="知情同意书签署">
              <el-switch :disabled="true" v-model="form.InformedConsent"></el-switch>
            </el-form-item>
          </el-col>
          <el-col v-if="OLD_IF && old_value.InformedConsent != form.InformedConsent" :span="7" :xs="24" class="yz_cls">
            {{ old_value_titile }}：{{ old_value.InformedConsent ? '开' : '关' }}
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6" :xs="14">
            <el-form-item label="讲者" prop="">
              <el-switch :disabled="HCP_IF == 'CK'" v-model="form.IsSpeaker"></el-switch>
              <!-- <el-link>555</el-link> -->
              <el-link
                v-if="OLD_IF && old_value.IsSpeaker != form.IsSpeaker"
                disabled
                :underline="false"
                style="padding-left: 10px; padding-top: 0"
                class="yz_cls"
              >
                {{ old_value_titile }}：{{ old_value.IsSpeaker ? '开' : '关' }}
              </el-link>
            </el-form-item>
          </el-col>
          <!-- <el-col v-if="OLD_IF && old_value.IsSpeaker != form.IsSpeaker" :span="4" :xs="10" style="padding-left:0" class="yz_cls">
            原值：{{ !old_value.IsSpeaker?'空':old_value.IsSpeaker?'开':'关' }}
          </el-col> -->
          <el-col :span="6" v-if="HCP_IF == 'CK'" :xs="24">
            <el-form-item label="拜访医生" prop="">
              <el-switch :disabled="HCP_IF == 'CK' || BU_IF_SB_JT" v-model="form.IsVisitDoctor"></el-switch>
              <el-link
                v-if="OLD_IF && old_value.IsVisitDoctor != form.IsVisitDoctor"
                disabled
                :underline="false"
                style="padding-left: 10px; padding-top: 0"
                class="yz_cls"
              >
                {{ old_value_titile }}：{{ old_value.IsVisitDoctor ? '开' : '关' }}
              </el-link>
            </el-form-item>
          </el-col>
          <!-- <el-col v-if="OLD_IF && old_value.IsVisitDoctor != form.IsVisitDoctor" :span="4" style="padding-left:0" :xs="10" class="yz_cls">
            原值：{{ !old_value.IsVisitDoctor?'空':old_value.IsVisitDoctor?'开':'关' }}
          </el-col> -->
        </el-row>
        <el-row>
          <el-col :span="6" :xs="24">
            <el-form-item label="术者" prop="">
              <el-switch :disabled="HCP_IF == 'CK'" v-model="form.IsSurgeon"></el-switch>
              <el-link
                v-if="OLD_IF && old_value.IsSurgeon != form.IsSurgeon"
                disabled
                :underline="false"
                style="padding-left: 10px; padding-top: 0"
                class="yz_cls"
              >
                {{ old_value_titile }}：{{ old_value.IsSurgeon ? '开' : '关' }}
              </el-link>
            </el-form-item>
          </el-col>
          <!-- <el-col v-if="OLD_IF && old_value.IsSurgeon != form.IsSurgeon" :span="4" :xs="10" style="padding-left:0" class="yz_cls">
            原值：{{ !old_value.IsSurgeon?'空':old_value.IsSurgeon?'开':'关' }}
          </el-col> -->
          <el-col :span="6" :xs="24">
            <el-form-item label="参会医生" prop="">
              <el-switch :disabled="HCP_IF == 'CK'" v-model="form.IsAttendingDoctor"></el-switch>
              <el-link
                v-if="OLD_IF && old_value.IsAttendingDoctor != form.IsAttendingDoctor"
                disabled
                :underline="false"
                style="padding-left: 10px; padding-top: 0"
                class="yz_cls"
              >
                {{ old_value_titile }}：{{ old_value.IsAttendingDoctor ? '开' : '关' }}
              </el-link>
            </el-form-item>
          </el-col>
          <!-- <el-col v-if="OLD_IF && old_value.IsAttendingDoctor != form.IsAttendingDoctor" :span="4" :xs="10" style="padding-left:0" class="yz_cls">
            原值：{{ !old_value.IsAttendingDoctor?'空':old_value.IsAttendingDoctor?'开':'关' }}
          </el-col> -->
        </el-row>
        <!-- </div> -->
        <!-- <div style="background-color:white;padding:30px;border-radius: 10px;margin-top:20px"> -->
        <!-- <p class='P_XT' v-if="form.IsSurgeon || form.IsSpeaker || form.IsVisitDoctor" style="">HCP补充信息</p> -->
        <p class="P_XT" style="">HCP补充信息</p>
        <el-row v-if="form.IsSurgeon || form.IsSpeaker">
          <el-col :span="7" :xs="24">
            <el-form-item label="医师执业证书编码" prop="LicenseID">
              <el-input :disabled="HCP_IF == 'CK'" v-model="form.LicenseID" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col v-if="OLD_IF && old_value.LicenseID != form.LicenseID" :span="7" :xs="24" class="yz_cls">
            {{ old_value_titile }}：{{ !old_value.LicenseID ? '空' : old_value.LicenseID }}
          </el-col>
        </el-row>
        <el-row v-if="form.IsVisitDoctor">
          <el-col :span="7" :xs="24">
            <el-form-item label="医师类型" prop="type">
              <el-select :disabled="HCP_IF == 'CK'" v-model="form.type" clearable placeholder="请选择">
                <el-option label="术者" value="术者"></el-option>
                <el-option label="谈话医生" value="谈话医生"></el-option>
                <el-option label="非临及手术室护士长" value="非临及手术室护士长"></el-option>
              </el-select>
              <!-- <el-input :disabled='HCP_IF == "CK"' v-model="form.type" placeholder="请输入"></el-input> -->
            </el-form-item>
          </el-col>
          <el-col v-if="OLD_IF && old_value.type != form.type" :span="7" :xs="24" class="yz_cls">
            {{ old_value_titile }}：{{ !old_value.type ? '空' : old_value.type }}
          </el-col>
        </el-row>
        <el-row v-if="form.IsSpeaker">
          <el-col :span="7" :xs="24">
            <el-form-item label="学会委员" prop="menber_society">
              <el-select @change="level_post" :disabled="HCP_IF == 'CK'" v-model="form.menber_society" clearable placeholder="请选择">
                <el-option v-for="item in SpeakerIndexLists.Level2" :label="item.TypeName" :value="item.TypeName"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col v-if="OLD_IF && old_value.menber_society != form.menber_society" :span="7" :xs="24" class="yz_cls">
            {{ old_value_titile }}：{{ !old_value.menber_society ? '空' : old_value.menber_society }}
          </el-col>
        </el-row>
        <el-row v-if="form.IsSpeaker">
          <el-col :span="7" :xs="24">
            <el-form-item label="教育背景" prop="education_background">
              <!-- <el-input :disabled='HCP_IF == "CK"' v-model="form.education_background" placeholder="请输入"></el-input> -->
              <el-select @change="level_post" :disabled="HCP_IF == 'CK'" v-model="form.education_background" clearable placeholder="请选择">
                <el-option v-for="item in SpeakerIndexLists.Level3" :label="item.TypeName" :value="item.TypeName"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col v-if="OLD_IF && old_value.education_background != form.education_background" :span="7" :xs="24" class="yz_cls">
            {{ old_value_titile }}：{{ !old_value.education_background ? '空' : old_value.education_background }}
          </el-col>
        </el-row>
        <el-row v-if="form.IsSpeaker">
          <el-col :span="7" :xs="24">
            <el-form-item label="工作/专业经历" prop="worke_xperience">
              <el-select @change="level_post" :disabled="HCP_IF == 'CK'" v-model="form.worke_xperience" clearable placeholder="请选择">
                <el-option v-for="item in SpeakerIndexLists.Level4" :label="item.TypeName" :value="item.TypeName"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col v-if="OLD_IF && old_value.worke_xperience != form.worke_xperience" :span="7" :xs="24" class="yz_cls">
            {{ old_value_titile }}：{{ !old_value.worke_xperience ? '空' : old_value.worke_xperience }}
          </el-col>
        </el-row>
        <el-row v-if="form.IsSpeaker">
          <el-col :span="7" :xs="24">
            <el-form-item label="发表文章" prop="Publications">
              <el-select @change="level_post" :disabled="HCP_IF == 'CK'" v-model="form.Publications" clearable placeholder="请选择">
                <el-option v-for="item in SpeakerIndexLists.Level5" :label="item.TypeName" :value="item.TypeName"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col v-if="OLD_IF && old_value.Publications != form.Publications" :span="7" :xs="24" class="yz_cls">
            {{ old_value_titile }}：{{ !old_value.Publications ? '空' : old_value.Publications }}
          </el-col>
        </el-row>
        <el-row v-if="form.IsSpeaker">
          <el-col :span="7" :xs="24">
            <el-form-item label="讲者评级" prop="Level">
              <el-input :disabled="true" v-model="form.Level" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col v-if="OLD_IF && old_value.Level != form.Level" :span="7" :xs="24" class="yz_cls">
            {{ old_value_titile }}：{{ !old_value.Level ? '空' : old_value.Level }}
          </el-col>
        </el-row>
        <!-- <el-form-item label="文件上传"> 
        <el-upload v-if="HCP_IF != 'CK'" style="display: inline-block; margin-right: 20px" class="upload-demo" ref="upload" action="/images/Upload/Flie" :show-file-list="false"
          :headers="token" :on-success="handleSuccess" :before-upload="handlebefore" :on-error="handonerror" :file-list="fileList">
          <el-button type="primary">上传</el-button>
        </el-upload>
        <el-button @click="btn_up_2(form.file_urls)" v-if="form.file_urls" type="primary">预览</el-button>
      </el-form-item> -->
        <el-row v-if="HCP_IF != 'ADD'">
          <el-col :span="7" :xs="24">
            <el-form-item label="数据来源">
              <el-input :disabled="true" v-model="form.Source" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="文件上传">
              <el-upload
                v-if="HCP_IF != 'CK'"
                action="/images/Upload/Flie"
                ref="upload_img"
                :headers="token"
                :on-success="handleSuccess"
                :before-upload="handlebefore"
                :before-remove="beforeRemove"
                :on-error="handonerror"
                multiple
                :file-list="fileList"
                :show-file-list="false"
              >
                <el-button type="primary">上传</el-button>
              </el-upload>
              <!-- <el-button @click="btn_up_1"  v-if="form.files" type="primary">下载</el-button> -->
              <!-- <el-button   v-if="form.files" @click="btn_up_1_yl(form.files)" type="primary">预览</el-button> -->
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="padding-left: 140px; margin-bottom: 20px; box-sizing: border-box">
          <div v-for="fit in file_ist" :key="fit" style="display: inline-block; margin-right: 5px; position: relative">
            <!-- <span class="demonstration">{{ fit }}</span> -->
            <el-image style="width: 100px; height: 100px" :src="'https://share.51i.cc/' + fit" :fit="fit">
              <div slot="error" class="image-slot">
                <el-image style="width: 100px; height: 100px" src="https://jnjh5.oss-cn-beijing.aliyuncs.com/masterdata/wj.png" :fit="fit"></el-image>
              </div>
            </el-image>
            <div
              style="
                font-size: 19px;
                position: absolute;
                top: 0px;
                left: 1px;
                color: white;
                width: 100px;
                height: 20px;
                background-color: rgba(0, 0, 0, 0.5);
                border-top-left-radius: 5px;
                border-top-right-radius: 5px;
              "
            >
              <i v-if="HCP_IF != 'CK'" style="float: right; cursor: pointer" @click="btn_clear_img(fit)" class="el-icon-close"></i>
              <!-- <i  style="float:left;cursor:pointer;"  @click="btn_up_1_yl(fit)"  class="el-icon-download"></i> -->
              <i style="float: left; cursor: pointer" @click="btn_up_1_yl(fit)" class="el-icon-zoom-in"></i>
            </div>
          </div>
          <div
            v-if="OLD_IF && old_value.file_urls !== form.file_urls"
            style="display: inline-block; position: relative; padding-left: 70px; box-sizing: border-box; min-width: 100px; min-height: 100px"
          >
            <span style="position: absolute; top: -10px; left: 0" class="yz_cls">{{ old_value_titile }}：{{ !old_value.file_urls ? '空' : '' }}</span>
            <div
              v-if="old_value.file_urls"
              v-for="fit in file_urls_list"
              :key="fit"
              style="display: inline-block; margin-right: 5px; position: relative"
            >
              <el-image style="width: 100px; height: 100px" :src="'https://share.51i.cc/' + fit" :fit="fit">
                <div slot="error" class="image-slot">
                  <el-image
                    style="width: 100px; height: 100px"
                    src="https://jnjh5.oss-cn-beijing.aliyuncs.com/masterdata/wj.png"
                    :fit="fit"
                  ></el-image>
                </div>
              </el-image>
              <div
                style="
                  font-size: 19px;
                  position: absolute;
                  top: 0px;
                  left: 1px;
                  color: white;
                  width: 100px;
                  height: 20px;
                  background-color: rgba(0, 0, 0, 0.5);
                  border-top-left-radius: 5px;
                  border-top-right-radius: 5px;
                "
              >
                <!-- <i v-if="TRYON_DETILS_IF != 'CKSQ'" style="float:right;cursor:pointer;" @click="btn_clear_img(fit)" class="el-icon-close"></i> -->
                <i style="float: left; cursor: pointer" @click="btn_up_1_yl(fit)" class="el-icon-zoom-in"></i>
              </div>
            </div>
          </div>
        </el-row>
        <el-row>
          <el-col :span="7" :xs="24">
            <el-form-item label="备注">
              <el-input :disabled="HCP_IF == 'CK'" type="textarea" v-model="form.remark" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col v-if="OLD_IF && old_value.remark != form.remark" :span="7" :xs="24" class="yz_cls">
            {{ old_value_titile }}：{{ !old_value.remark ? '空' : old_value.remark }}
          </el-col>
        </el-row>
        <!-- <el-row>
        <el-col :span="7" :xs="24">
          <el-form-item label="HCP ID" prop="HCPID">
            <el-input :disabled='HCP_IF == "CK"' v-model="form.HCPID" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
      </el-row> -->
        <!-- <el-row>
        
        <el-col :span="7" :xs="24">
          <el-form-item label="一级科室" prop="stair_departments_id">
            <el-input :disabled='HCP_IF == "CK"' v-model="form.stair_departments_id" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="7" :xs="24">
          <el-form-item label="二级科室" prop="second_departments_id">
            <el-input :disabled='HCP_IF == "CK"' v-model="form.second_departments_id" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
      </el-row> -->
        <br />
        <el-button @click="save('form')" v-if="HCP_IF != 'CK' || YXQ_IF == true" v-preventReClick="3000" type="primary">保 存</el-button>
        <el-button @click="onBack()">返回</el-button>
      </div>
    </el-form>
    <el-dialog title="提示" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
      <el-input type="textarea" v-model="approval_request_Put_Material_list.reason"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="turn_approvals()">确 定</el-button>
      </span>
    </el-dialog>
  </section>
</template>

<script>
import util from '../../../util/date'
import {
  HcpGetByid,
  Employee_GetCurrentEmployee,
  HcpAddHCP,
  HcpUpdataHCP,
  HcpApproval,
  approval_requestGetApprovalInfoByID,
  HcoQueryByStr,
  regionGetRegionTree,
  DepartmentsGetDepartmentsTree,
  DepartmentsQueryPage,
  HcpGetSpeakerIndexLists,
  HcpComputeScore,
} from '../../api/api'
import { getButtonList } from '../../promissionRouter'
import Toolbar from '../../components/Toolbar'

export default {
  components: { Toolbar },
  data() {
    return {
      MKT_IF: false,
      BU_IF_SB_JT: false,
      file_urls_list: [],
      OLD_IF: false,
      file_ist: [],
      old_value: {},
      old_value_titile: '原值',
      YXQ_IF: false,
      fileList: [],
      city_list: [],
      region_list: [],
      departments_list: [],
      HospitalName_options: [],
      approval_request_Put_Material_list: {
        approval_data_id: this.$route.query.approval_data_id,
        type: '已通过',
        state: 0,
        approvalstate: false,
        msg: '',
        data: {
          HCPID: '',
          ID: this.$route.query.id,
        },
      },
      dialogVisible: false,
      Sales_analytics_msg: false,
      request_list: [],
      description_text: '',
      rolename_if: false,
      num_zt: 0,
      HCP_IF: this.$route.query.type,
      SP_IF: this.$route.query.status,
      token: {},
      form: {
        IsAttendingDoctor: true,
        file_urls: '',
      },
      editFormRules: {
        HospitalName: [{ required: true, message: '请填写', trigger: 'blur' }],
        type: [{ required: true, message: '请填写', trigger: 'change' }],
        MultipleHospitalName: [{ required: true, message: '请填写', trigger: 'blur' }],
        stair_departments_id_Name: [{ required: true, message: '请填写', trigger: 'blur' }],
        second_departments_id_Name: [{ required: true, message: '请填写', trigger: 'blur' }],
        Name: [{ required: true, message: '请填写', trigger: 'blur' }],
        Gender: [{ required: true, message: '请填写', trigger: 'blur' }],
        HospitalID: [{ required: true, message: '请填写', trigger: 'blur' }],
        bwacctnumber: [{ required: true, message: '请填写', trigger: 'blur' }],
        multiple_hospitalid: [{ required: true, message: '请填写', trigger: 'blur' }],
        multiple_bwacctnumber: [{ required: true, message: '请填写', trigger: 'blur' }],
        LicenseID: [{ required: true, message: '请填写', trigger: 'blur' }],
        Title: [{ required: true, message: '请填写', trigger: 'blur' }],
        menber_society: [{ required: true, message: '请填写', trigger: 'blur' }],
        education_background: [{ required: true, message: '请填写', trigger: 'blur' }],
        worke_xperience: [{ required: true, message: '请填写', trigger: 'blur' }],
        Publications: [{ required: true, message: '请填写', trigger: 'blur' }],
        Level: [{ required: true, message: '请填写', trigger: 'blur' }],
        IsVisitDoctor: [{ required: true, message: '请填写', trigger: 'blur' }],
        HCPID: [{ required: true, message: '请填写', trigger: 'blur' }],
        stair_departments_id: [{ required: true, message: '请填写', trigger: 'blur' }],
        second_departments_id: [{ required: true, message: '请填写', trigger: 'blur' }],
        province_name: [{ required: true, message: '请填写', trigger: 'blur' }],
        city_name: [{ required: true, message: '请填写', trigger: 'blur' }],
        IsSpeaker: [{ required: true, message: '请填写', trigger: 'blur' }],
        IsSurgeon: [{ required: true, message: '请填写', trigger: 'blur' }],
        IsAttendingDoctor: [{ required: true, message: '请填写', trigger: 'blur' }],
      },
      SalesOperation_if: false,
      edit_if_2: false,
      edit_if: true,
      buttonList: [],
      managercode_list: [],
      currentRow: null,
      filters: {
        pageSize: 50,
      },
      users: [],
      statusList: [
        { LinkUrl: '激活', value: true },
        { LinkUrl: '禁用', value: false },
      ],
      total: 0,
      page: 1,
      listLoading: false,
      sels: [], //列表选中列
      stair_list: [],
      SpeakerIndexLists: [],
      second_list: [],
    }
  },
  methods: {
    cancalReadOnly(value) {
      this.$nextTick(() => {
        if (!value) {
          const { select } = this.$refs
          const input = select.$el.querySelector('.el-input__inner')
          const { select1 } = this.$refs
          const input1 = select1.$el.querySelector('.el-input__inner')
          input.removeAttribute('readonly')
          input1.removeAttribute('readonly')
        }
      })
    },
    handlebefore() {
      const loading = this.$loading({
        lock: true,
        text: 'loading......',
      })
    },
    btn_up_1_yl(e) {
      window.open('https://preview.51i.cc/onlinePreview?url=' + encodeURIComponent('https://share.51i.cc/' + e))
      // }
    },
    btn_clear_img(e) {
      this.$confirm('确定删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          for (var i in this.file_ist) {
            if (this.file_ist[i] == e) {
              this.file_ist.splice(i, 1)
            }
          }
        })
        .catch(() => {})
    },
    btn_up_YX(e) {
      window.open('/api/' + e)
    },
    btn_up_2(e) {
      window.open('https://preview.51i.cc/onlinePreview?url=' + encodeURIComponent('https://' + location.host + '/' + e))
    },
    async level_post() {
      var para = {
        Title: this.form.Title,
        menber_society: this.form.menber_society,
        WorkExperience: this.form.worke_xperience,
        education_background: this.form.education_background,
        Publications: this.form.Publications,
      }
      this.loading = this.$loading({
        lock: true,
        text: 'loading......',
      })
      const { data } = await HcpComputeScore(para)
      this.form.Level = data.response.Level
      var forms = JSON.parse(JSON.stringify(this.form))
      forms.Level = data.response.Level
      this.form = forms
      this.loading.close()
      //   console.log(data)
    },
    MultipleHospitalchange(e, type) {
      this.HospitalName_options.find((item) => {
        if (item.Name === e) {
          if (type == 'yy') {
            this.form.province_name = item.province_name
            this.form.city_name = item.city_name
            this.form.HospitalID = item.ID
            this.form.bwacctnumber = item.BWAcctNumber
          } else {
            this.form.ModifyID = item.ID
            this.form.multiple_bwacctnumber = item.BWAcctNumber
            this.form.multiple_hospitalid = item.ID
          }
        }
      })
    },
    second_change(e) {
      this.second_list.find((item) => {
        if (item.Name === e) {
          this.form.second_departments_id = item.ID
          // this.city_list = item.children
        }
      })
    },
    Departments_change(e) {
      this.stair_list.find((item) => {
        if (item.Name === this.form.stair_departments_id_Name) {
          this.form.stair_departments_id = item.ID
          this.second_list = item.children
          console.log(this.second_list)
        }
      })
    },
    async DepartmentsQueryPage_fn() {
      const { data } = await DepartmentsQueryPage()
      this.stair_list = data.response
    },
    onBack() {
      console.log(this.$route.query.filters_list)
      this.$router.push({
        path: this.$route.query.back_url,
        query: {
          filters_list: this.$route.query.filters_list,
        },
      })
      //   this.$router.push();
      //   filters_list
    },
    city_change(e) {
      this.city_list.find((item) => {
        if (item.name === e) {
          this.form.CityID = item.CityID
          // this.city_list = item.children
        }
      })
    },
    province_change(e) {
      this.region_list.find((item) => {
        if (item.name === this.form.province_name) {
          this.form.ProvinceID = item.id
          this.city_list = item.children
          console.log(this.form.ProvinceID)
        }
      })
    },
    async HospitalName_chage(e) {
      const { data } = await HcoQueryByStr({
        code: e,
      })
      this.HospitalName_options = data.response
      console.log(this.HospitalName_options)
      console.log(data)
    },
    querySearch(queryString, cb) {
      var restaurants = this.restaurants
      var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants
      // 调用 callback 返回建议列表的数据
      cb(results)
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then((_) => {
          done()
        })
        .catch((_) => {})
    },

    // 审批接口
    approval_request_Puts() {
      HcpApproval(this.approval_request_Put_Material_list).then((res) => {
        if (res.data.status == 200) {
          this.$message({
            message: res.data.msg,
            type: 'success',
          })
          this.$router.push(this.$route.query.back_url)
          this.dialogVisible = false
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
          })
        }
      })
    },
    turn_approvals() {
      //   this.approval_request_Put_Material_list.state = -1;
      //   this.approval_request_Put_Material_list.type = "已驳回";
      this.approval_request_Put_Material_list.approvalstate = false
      this.approval_request_Puts()
    },
    submit_approvals() {
      //   this.approval_request_Put_Material_list.state = 0;
      if (this.request_list.isadmin) {
        if (!this.approval_request_Put_Material_list.data.HCPID) {
          this.$message({
            message: '请输入HCP ID',
            type: 'error',
          })
          return
        }
      }
      this.approval_request_Put_Material_list.approvalstate = true
      this.$confirm('确认同意？')
        .then((_) => {
          this.approval_request_Puts()
        })
        .catch((_) => {})
    },
    // 审核进度
    approval_request_Get(id) {
      // console.log(this.$route.query.type_accu);
      let para_s = {}
      para_s = {
        approval_data_id: this.$route.query.approval_data_id,
        tag: 'hcp',
      }
      approval_requestGetApprovalInfoByID(para_s).then((res) => {
        if (res.data.response) {
          let num_zt = 0
          for (var i in res.data.response.ApprovalDataInfoList) {
            if (res.data.response.ApprovalDataInfoList[i].adireason == 0) {
              num_zt++
            }
          }
          if (res.data.response.state == '-1') {
            this.description_text = res.data.response.reason
          }
          // if (res.data.response[2].state == "-1") {
          //   this.description_text = res.data.msg;
          // }
          if (res.data.response.old_value) {
            // this.old_value = JSON.parse(res.data.response.old_value)
            if (res.data.response.state == -1) {
              this.old_value = res.data.response.new_value_data
              this.old_value_titile = '修改值'
            } else {
              this.old_value = res.data.response.old_value_data
              this.old_value_titile = '原值'
            }
            this.OLD_IF = true
            this.old_value.file_urls == null ? (this.old_value.file_urls = '') : ''
            if (this.old_value.file_urls) {
              this.file_urls_list = this.old_value.file_urls.split(',')
            }
            console.log(this.old_value)
          }
          this.num_zt = num_zt
          this.request_list = res.data.response
          //   this.form.HCPID = 999
          if (res.data.response.isadmin) {
            this.approval_request_Put_Material_list.data.HCPID = this.form.HCPID
            // console.log(5555)
          }

          //   if (res.data.response)
          //   {
          //     this.request_list_name = res.data.response[0].username;
          //   }
          //   console.log(this.request_list.length);
          //   for (var i in this.request_list)
          //   {
          //     console.log(this.request_list[i].createtime);
          //     this.request_list[i].createtime = this.formattime(
          //       this.request_list[i].createtime
          //     );
          //     this.request_list[i].timestamp = this.formattime(
          //       this.request_list[i].timestamp
          //     );
          //   }
        }
      })
    },
    async save(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this.form.file_urls = this.file_ist.toString()
          if (this.$route.query.type == 'ADD') {
            // console.log(this.form)
            // return

            var { data } = await HcpAddHCP(this.form)
          } else {
            var { data } = await HcpUpdataHCP(this.form)
          }
          if (data.status == 200) {
            this.$message({
              message: data.msg,
              type: 'success',
            })
            this.onBack()
            // this.$router.push(this.$route.query.back_url)
          } else {
            this.$message({
              message: data.msg,
              type: 'error',
            })
          }
        } else {
          return
        }
      })
    },
    handonerror() {
      console.log('超时失败')

      const loading = this.$loading({
        lock: true,
        text: 'loading......',
      })
      this.$message({
        message: '您的上传已超时，请再次尝试',
        type: 'error',
      })
      loading.close()
    },
    beforeRemove(file, fileList) {
      console.log(file)
      console.log(fileList)
      return this.$confirm(`确定移除 ${file.name}？`, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        for (var i in this.file_ist) {
          if (this.file_ist[i] == file.response.response) {
            this.file_ist.splice(i, 1)
          }
          console.log(this.file_ist)
        }
        this.$message({
          type: 'success',
          message: '删除成功!',
        })
      })
      // .catch(() => {
      //   this.$message({
      //     type: 'info',
      //     message: '已取消删除'
      //   });
      // });
    },
    handleSuccess(file, fileList) {
      const loading = this.$loading({
        lock: true,
        text: 'loading......',
      })
      if (file.success) {
        loading.close()
        this.$message({
          message: file.msg,
          type: 'success',
        })
        this.file_ist.push(file.response)
      } else {
        loading.close()
        this.$message({
          message: file.msg,
          type: 'error',
        })
      }
    },
    ExportAccount() {
      // let para = this.filters
      var organization_id = localStorage.getItem('organization_id')
      let para = {
        organization_id: organization_id,
      }
      //  para.account_manager = para.account_manager.toString()
      //  window.open("​/api​/store_data​/ExportStore?")
      member_overrun_ExportExcel(para).then((res) => {
        //window.open("http://47.103.87.196:8082" + res.data.msg);
        window.location.href = res.data.msg
      })
    },
    async regionGetRegionTree_fn() {
      const { data } = await regionGetRegionTree()
      this.region_list = data.response
    },
    async DepartmentsGetDepartmentsTree_fn() {
      const { data } = await DepartmentsGetDepartmentsTree()
      this.departments_list = data.response
    },

    async getDetails() {
      console.log(this.$route.query.id)
      const { data } = await HcpGetByid({ id: this.$route.query.id })
      this.form = data.response
      //   if(this.$route.query.type != 'CK'){
      //     this.form.IsAttendingDoctor = true
      //   }
      if (data.response.stair_departments_id_Name) {
        this.Departments_change(data.response.stair_departments_id_Name)
      }
      data.response.file_urls == null ? (data.response.file_urls = '') : ''
      if (data.response.file_urls) {
        this.file_ist = data.response.file_urls.split(',')
      }
      this.province_change()
    },
    selsChange: function (sels) {
      this.sels = sels
    },
    async HcpGetSpeakerIndexLists() {
      const { data } = await HcpGetSpeakerIndexLists()
      this.SpeakerIndexLists = data.response
    },
  },
  async mounted() {
    let tokenStr = window.localStorage.Token
    this.token = {
      Authorization: 'Bearer ' + tokenStr,
    }
    var user_details = JSON.parse(window.localStorage.getItem('user'))
    var user_RoleNames = user_details.RoleNames
    this.MKT_IF =
      user_RoleNames.filter(function (e) {
        return e == '管理员' || e == 'MKT' || e == 'SuperAdmin'
      }).length != 0
    this.HospitalName_chage('')
    this.DepartmentsQueryPage_fn()
    this.HcpGetSpeakerIndexLists()

    this.regionGetRegionTree_fn()
    this.DepartmentsGetDepartmentsTree_fn()
    const { data } = await Employee_GetCurrentEmployee()
    this.BU_IF = data.response.BU
    // if (data.response.BU == '晶体事业部')
    // {
    //   if (this.$route.query.type == 'ADD')
    //   {
    //     this.BU_IF_REF_CAT = false
    //   }

    // }
    if (data.response.BU == '飞秒激光及眼表事业部') {
      //   if (this.$route.query.type == 'ADD')
      //   {
      this.BU_IF_SB_JT = true
      //   }
    }
    if (this.$route.query.type != 'ADD') {
      this.getDetails()
    }
    if (this.$route.query.type == 'CK') {
      if (this.$route.query.status == 'YXQ') {
        this.YXQ_IF = true
      }
      this.approval_request_Get(this.$route.query.id)
    }
  },
}
</script>

<style scoped>
.yz_cls {
  padding-left: 30px;
  padding-top: 8px;
  font-size: 14px;
  color: rgb(233, 119, 88) !important;
}
.demo-input-suffix {
  display: inline-block;
  margin-right: 15px;
}
/* .demo-input-suffix > .el-input {
  width: 150px;
  margin-bottom: 20px;
} */
/* .stores >>> .el-form-item__content {
  width: 100%;
} */
.stores >>> .el-select,
.stores >>> .el-date-editor {
  width: 100%;
}
.el-form-item__error {
  top: 19% !important;
  right: -29% !important;
}
</style>
